import { TransactionStatus } from "@common/types/transaction";
import {
    TransactionColumn,
    TransactionView,
} from "@common/types/views/transactionViews";
import { ViewType } from "@common/types/views/views";

/**
 * Columns of the transaction-based schedule review tasks (suspicious
 * transactions and rule-suggested schedules). Defined in `common/` so the
 * backend task-view persistence and the frontend task bodies share one shape.
 */
export const SCHEDULE_REVIEW_COLUMNS: TransactionView["columns"] = [
    {
        id: TransactionColumn.LOCK,
        options: { pin: "left" },
    },
    {
        id: TransactionColumn.DATE,
        options: { pin: "left" },
    },
    {
        id: TransactionColumn.BANK_DESCRIPTION,
    },
    {
        id: TransactionColumn.COUNTERPARTY,
    },
    {
        id: TransactionColumn.CATEGORY,
    },
    {
        id: TransactionColumn.AMOUNT,
    },
    {
        id: TransactionColumn.ENTITY,
    },
    {
        id: TransactionColumn.SCHEDULE,
        options: { pin: "right" },
    },
    {
        id: TransactionColumn.SCHEDULE_REVIEW_ACTIONS,
        options: { pin: "right" },
    },
];

export const SCHEDULE_REVIEW_VIEW_OPTIONS: TransactionView["options"] = {
    bulkActions: true,
    selection: true,
};

export function createScheduleSuspiciousReviewDefaultView(
    entityIds: number[],
): TransactionView {
    return {
        type: ViewType.TRANSACTION,
        options: SCHEDULE_REVIEW_VIEW_OPTIONS,
        columns: SCHEDULE_REVIEW_COLUMNS,
        filters: {
            entityIds,
            isScheduleSuspicious: true,
            statuses: [TransactionStatus.COMPLETED],
        },
    };
}

export function createScheduleRuleSuggestedReviewDefaultView(
    entityIds: number[],
): TransactionView {
    return {
        type: ViewType.TRANSACTION,
        options: SCHEDULE_REVIEW_VIEW_OPTIONS,
        columns: SCHEDULE_REVIEW_COLUMNS,
        filters: {
            entityIds,
            hasScheduleDraft: true,
            statuses: [TransactionStatus.COMPLETED],
        },
    };
}
